import {openResourceModal} from '../../core/modalCommand';
import {
	AAA_SERVER_CREATE_MODAL_EVENT,
	AAA_SERVER_DELETE_MODAL_EVENT,
	AAA_SERVER_EDIT_MODAL_EVENT,
} from './events';

/**
 * Open Add AAA Server.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openAaaServerCreateModal(command, envelope) {
	return openResourceModal(AAA_SERVER_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open Edit AAA Server.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openAaaServerEditModal(command, envelope) {
	return openResourceModal(AAA_SERVER_EDIT_MODAL_EVENT, command, envelope);
}

/**
 * Open Delete AAA Server.
 *
 * The confirmation, not the deletion. Nothing is removed until the
 * person presses the button inside it.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openAaaServerDeleteModal(command, envelope) {
	return openResourceModal(AAA_SERVER_DELETE_MODAL_EVENT, command, envelope);
}
